// Calendar Component
import { t, getLanguage } from '../i18n.js';

export function createCalendar(containerId, options = {}) {
    const {
        onDateSelect = () => { },
        availableDates = [],  // array of 'YYYY-MM-DD' strings
        selectedDate = null,
        minDate = new Date()
    } = options;

    let currentMonth = new Date();
    let selected = selectedDate;

    function render() {
        const container = document.getElementById(containerId);
        if (!container) return;

        const year = currentMonth.getFullYear();
        const month = currentMonth.getMonth();
        const isThai = getLanguage() === 'th';
        const displayYear = isThai ? year + 543 : year;
        const firstDay = new Date(year, month, 1).getDay();
        const daysInMonth = new Date(year, month + 1, 0).getDate();
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const MONTHS = t('date_months');
        const DAYS = t('date_days');

        let html = `
      <div class="calendar">
        <div class="calendar-header">
          <button class="calendar-nav" id="cal-prev">‹</button>
          <span class="calendar-title">${MONTHS[month]} ${displayYear}</span>
          <button class="calendar-nav" id="cal-next">›</button>
        </div>
        <div class="calendar-grid">
          ${DAYS.map(d => `<div class="calendar-day-label">${d}</div>`).join('')}
    `;

        // Empty cells before first day
        for (let i = 0; i < firstDay; i++) {
            html += '<div class="calendar-day empty"></div>';
        }

        // Day cells
        for (let day = 1; day <= daysInMonth; day++) {
            const date = new Date(year, month, day);
            const dateStr = formatDate(date);
            const isToday = date.getTime() === today.getTime();
            const isPast = date < today;
            const isAvailable = availableDates.includes(dateStr);
            const isSelected = selected === dateStr;
            const isDisabled = isPast || !isAvailable;

            const classes = [
                'calendar-day',
                isToday ? 'today' : '',
                isSelected ? 'selected' : '',
                !isDisabled ? 'available' : '',
                isDisabled ? 'disabled' : ''
            ].filter(Boolean).join(' ');

            html += `<button class="${classes}" data-date="${dateStr}" ${isDisabled ? 'disabled' : ''}>${day}</button>`;
        }

        html += '</div></div>';
        container.innerHTML = html;

        // Bind events
        document.getElementById('cal-prev')?.addEventListener('click', () => {
            currentMonth.setMonth(currentMonth.getMonth() - 1);
            render();
        });

        document.getElementById('cal-next')?.addEventListener('click', () => {
            currentMonth.setMonth(currentMonth.getMonth() + 1);
            render();
        });

        container.querySelectorAll('.calendar-day:not(.disabled):not(.empty)').forEach(btn => {
            btn.addEventListener('click', () => {
                selected = btn.dataset.date;
                render();
                onDateSelect(selected);
            });
        });
    }

    render();

    return {
        render,
        getSelected: () => selected,
        setAvailableDates: (dates) => {
            options.availableDates = dates;
            render();
        }
    };
}

function formatDate(date) {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
}

export function formatThaiDate(dateStr) {
    if (!dateStr) return '';
    const [y, m, d] = dateStr.split('-').map(Number);
    const months = t('date_months');
    const isThai = getLanguage() === 'th';
    const displayYear = isThai ? y + 543 : y;
    return `${d} ${months[m - 1]} ${displayYear}`;
}

export function formatThaiDateTime(dateStr, timeStr) {
    if (!dateStr || !timeStr) return '';
    const dateFormatted = formatThaiDate(dateStr);
    return t('date_time_format').replace('{date}', dateFormatted).replace('{time}', timeStr);
}
